module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "describe"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("可追溯商品总量")]), _vm._v(" "), _c('div', {
    staticClass: "total-num"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "num"
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("扫码区域")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "main"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b3fa162!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/trace/components/center/index.vue
// module id = 1996
// module chunks = 2